// removed by extract-text-webpack-plugin
module.exports = {"container":"G631W","postTitle":"_3QGJf","content":"_2sYXt"};


//////////////////
// WEBPACK FOOTER
// ./app/components/comment-search-list-item/comment-search-list-item.scss
// module id = 1791
// module chunks = 0